'use strict';
import { addBrowserClasses } from './modules/_utils';
import './nav/main.js';
import Glide from '@glidejs/glide'


document.addEventListener('DOMContentLoaded', function() {


  document.getElementsByClassName('no-js')[0].classList.remove('no-js');

  // Common functions
  addBrowserClasses();

  // Hubspot cookie settings links in footer
  const hubspotCookieSettings = document.getElementById('hs-footer-cookie-settings');
  if (hubspotCookieSettings) {
    hubspotCookieSettings.addEventListener('click', function(e) {
      e.preventDefault();
      var _hsp = window._hsp = window._hsp || [];
      _hsp.push(['showBanner']);
    });
  }

  // const testimonialsSlider = new Glide('.testimonials-slider', {
  //   type: 'carousel',
  //   perView: 1,
  //   autoplay: 6000,
  // });
  // testimonialsSlider.mount();

  if (document.querySelector('.carousel-slider')) {
    const carouselSlider = new Glide('.carousel-slider', {
      type: 'carousel',
      perView: 5,
      peek: {
        before: 0,
        after: 50
      },
      gap: 16,
      breakpoints: {
        768: {
          perView: 1,
          peek: {
            before: 0,
            after: 100
          }
        },
        1200: {
          perView: 2,
          peek: {
            before: 0,
            after: 100
          }
        },
        1440: {
          perView: 4
        }
      }
    });
    carouselSlider.mount();

  }


});
